
import React from 'react';
import { useLanguage } from './LanguageContext';
import { TRANSLATIONS, TRUST_SIGNALS, ICON_MAP } from '../constants';

const TrustSignals: React.FC = () => {
  const { language } = useLanguage();
  const t = TRANSLATIONS[language];
  const signals = TRUST_SIGNALS[language];

  return (
    <section id="trust" className="py-24 bg-[#f9f9f9]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-4">{t.trustTitle}</h2>
          <div className="w-20 h-1 bg-[#c5a059] mx-auto mb-6"></div>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg">{t.trustSubtitle}</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {signals.map((signal, idx) => (
            <div 
              key={idx} 
              className="bg-white p-10 text-center rounded-sm shadow-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border-b-4 border-transparent hover:border-[#c5a059]"
            >
              <div className="text-[#c5a059] flex justify-center mb-6">
                {ICON_MAP[signal.icon]}
              </div>
              <h3 className="text-xl font-bold mb-4 tracking-tight">{signal.title}</h3>
              <p className="text-gray-500 leading-relaxed">{signal.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustSignals;
